import getMapData from './_getMapData.js';

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

export default mapCacheDelete;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_mapCacheDelete.js
// module id = 1263
// module chunks = 14